import SectionHeader from './SectionHeader'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const testimonials = [
  {
    quote: "The DRIP snowball calculator alone is worth it — seeing my income compound to $8K/month in 15 years keeps me motivated to stay the course. I've tried spreadsheets and other apps; nothing comes close.",
    initials: 'MR',
    name: 'Michael R.',
    title: 'Retired engineer · Dividend investor since 2009',
    tag: 'Tracking $8K/mo projected',
  },
  {
    quote: "The dividend calendar changed how I manage cashflow. I can see exactly which weeks income hits. Brokerage sync means I never forget to log a trade. Setup took 5 minutes.",
    initials: 'SK',
    name: 'Sarah K.',
    title: 'Financial independence blogger',
    tag: 'Tracking $1,850+/month',
  },
  {
    quote: "Managing three separate accounts used to be a nightmare. Now everything's in one dashboard — DRIP projections, options income, dividend alerts. Incredible value.",
    initials: 'DT',
    name: 'David T.',
    title: 'Portfolio: $620K across 3 accounts',
    tag: '$620K portfolio, 3 accounts',
  },
]

export default function TestimonialsSection() {
  const ref = useScrollAnimation({ childSelector: '.testimonial-card', stagger: 0.15 })

  return (
    <section className="bg-[#F8FAFC] section-padding">
      <div className="content-max">
        <SectionHeader overline="Trusted by thousands of income investors" headline="What our investors say" />

        <div ref={ref} className="mt-12 grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="testimonial-card bg-white border border-[#E2E8F0] rounded-xl p-8 hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300"
            >
              {/* Dollar Icon */}
              <div className="w-10 h-10 rounded-full bg-[#F0FDF4] flex items-center justify-center mb-5">
                <span className="text-[#1B5E20] text-lg font-bold">$</span>
              </div>

              {/* Quote */}
              <p className="text-base text-[#475569] leading-relaxed italic mb-6">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#DCFCE7] flex items-center justify-center">
                  <span className="text-sm font-semibold text-[#1B5E20]">{t.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-[#0F172A]">{t.name}</p>
                  <p className="text-xs text-[#94A3B8]">{t.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
